// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mf-2";
export var interactiveWrapper = "_mf-0";
export var shippingHoverPreview = "_mf-4";
export var summaryBadgeTrigger = "_mf-1";
export var widgetHoverPreviewList = "_mf-3";
export var widgetPreviewScale = "_mf-5";